import React from 'react';
import { useGiftWrapContext } from '../../context/GiftWrapContext';
import { useLocale } from '../../context/LocaleContext';
import { useUserInput } from '../../context/UserInputContext.tsx';
import { getInsertsAndCardsProduct } from '../../utilities/visualiserVariants.js';
import { buildSummaryLines, buildVisualiserSummaryLine } from '../priceSummary';
import styles from '../packaging.module.css';

/** "View Summary": the piece, every packaging line and the insert or card, priced as the cart will charge. */
export function PackagingSummary() {
  const { priceModalOpen, setPriceModalOpen, personalisationChoices, wrapOptions, activeProduct } = useGiftWrapContext();
  const { formatPrice } = useLocale();
  const { visualiserSelection } = useUserInput();
  if (!priceModalOpen) return null;

  const visualiserLine = buildVisualiserSummaryLine({
    ...visualiserSelection,
    product: visualiserSelection?.productKey
      ? getInsertsAndCardsProduct({ productKey: visualiserSelection.productKey })
      : null
  });
  const lines = [
    ...buildSummaryLines({ personalisationChoices, wrapOptions }),
    ...(visualiserLine ? [visualiserLine] : [])
  ];

  return (
    <div className={styles.summary} role="region" aria-label="Summary">
      <ul className={styles.summaryList}>
        {activeProduct?.title && (
          <li className={styles.summaryRow}>
            <span>{activeProduct.title}</span>
            <span>{formatPrice({ amount: activeProduct.price })}</span>
          </li>
        )}
        {lines.map((line) => (
          <li key={line.key} className={styles.summaryRow}>
            <span>
              {line.label}
              {line.detail ? `, ${line.detail}` : ''}
            </span>
            <span>{line.amount ? formatPrice({ amount: line.amount }) : 'Included'}</span>
          </li>
        ))}
      </ul>
      <button type="button" className="button button--secondary button--black button--full-width" onClick={() => setPriceModalOpen(false)}>
        Close
      </button>
    </div>
  );
}
